
/**
 * Sand
 * 
 * @version 1.0.1
 */
class Sand {

    /**
     * Instance of Sand
     */
    _instance = null;

    /**
     * Boolean to check if Sand has data
     */
    hasData = false;

    /**
     * Sand singleton constructor
     * @param {string} url 
     * @return Sand
     */
    constructor(url, sha) {
        if (!Sand._instance) {

            // First we try to load sha from localStorage
            let _sha = window.localStorage.getItem('sand_sha');

            // Check if sha is different or null and call the url to get all data and save it
            if (null === _sha || _sha !== sha) {
                // Sha is different or null, call the url to get all data and save it
                this.fetchData(url);
            } else {
                // Sha is the same, load the data from localStorage
                this.loadData();
            }

            Sand._instance = this;
            window.Sand = this;

        }
        return Sand._instance;
    }

    /**
     * Fetch data from input url and set items to the instance and local storage
     * @param {string} url 
     */
    fetchData(url) {
        fetch(url)
            .then(response => response.json())
            .then(data => {
                window.localStorage.setItem('sand_sha', data.sha);
                window.localStorage.setItem('sand_lang', data.lang);
                window.localStorage.setItem('sand_translations', data.translations);

                this._sha = data.sha;
                this._lang = data.lang;
                this._translations = JSON.parse(data.translations)

                this.hasData = true;
            })
            .catch(error => console.error(error));
    }

    /**
     * Loads data from local storage to the instance
     */
    loadData() {
        this._sha = window.localStorage.getItem('sand_sha');
        this._lang = window.localStorage.getItem('sand_lang');
        this._translations = JSON.parse(window.localStorage.getItem('sand_translations'));

        this.hasData = true;
    }

    /**
     * Returns translation for key if it exists, key otherwose
     * @param {string} key 
     * @returns 
     */
    get(key) {
        return (null === this._translations) ? key : (this._translations[key] ? this._translations[key] : key);
    }

    /**
     * Return all the translations object
     * @returns 
     */
    getAll() {
        return this._translations;
    }
    
    /**
     * Return Sand instance
     * @returns Sand
     */
    getInstance() {
        return Sand._instance;
    }

}

export default Sand;